<template>
    <div class="relative bg-gray-50 pt-16 overflow-hidden sm:pt-24 lg:pt-32" id="leagues">
        <div class="mx-auto max-w-md px-4 text-center sm:px-6 sm:max-w-3xl lg:px-8 lg:max-w-7xl">
            <div>
                <span class="h-12 w-12 rounded-md flex items-center mx-auto bg-gray-800 mb-3">
                    <ChartBarIcon class="h-6 w-6 text-white mx-auto" aria-hidden="true" />
                </span>
                <h2 class="text-base font-semibold tracking-wider text-gray-700 uppercase">Mini leagues</h2>
                <p class="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
                    Compete with Others
                </p>
                <p class="mt-5 max-w-prose mx-auto text-xl text-gray-500">
                    Keep an eye on your competition and track your progress against friends in mini leagues!                
                </p>
            </div>
            <div class="mt-10">
                <img class="mx-auto rounded-lg shadow-xl ring-1 ring-black ring-opacity-5" :src="asset('images/mini_leagues.png')" alt="" />
            </div>
        </div>
    </div>
</template>
<script>
import { DatabaseIcon, SparklesIcon, ChartBarIcon } from '@heroicons/vue/outline'

export default {
    components: {
        DatabaseIcon,
        SparklesIcon,
        ChartBarIcon
    }
}

</script>
